/**
 * Utility function to ensure an API call with a callback is displayed for a minimum amount of time
 * @param apiCall - Function that makes the API call with a callback
 * @param minDelayMs - Minimum delay in milliseconds (default: 2000)
 * @returns Promise that resolves with the API result after both API call and minimum delay complete
 */
export const delayedApiCall = <T>(
    apiCall: (callback: (success: boolean, result: T) => void) => void,
    minDelayMs: number = 2000,
): Promise<{ success: boolean; result: T }> => {
    const apiPromise = new Promise<{ success: boolean; result: T }>((resolve) => {
        apiCall((success, result) => resolve({ success, result }));
    });

    const minDelayPromise = new Promise<void>((resolve) => {
        setTimeout(resolve, minDelayMs);
    });

    return Promise.all([apiPromise, minDelayPromise]).then(([apiResult]) => apiResult);
};
